export const apiUrl = "https://menu.doremolab.com/api/";

export const apiKey = "r9chefhA9xsBjsF824R2";

export const storageUrl = "https://menu.doremolab.com/storage/";

export const loginUrl = `${apiUrl}login`;
export const logOutUrl = `${apiUrl}logout`;

export const CategoriesUrl = `${apiUrl}app/categories`;

export const productsUrl = `${apiUrl}app/products`;
